import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../../LinkyLinky';
import { ImportedParticipantsResource } from '../../../../../Store/Types';
import AddParticipantsToGroupFormStore from '../../Store';
import { FilterOption } from './GroupDynamicTypeaheadSelect/UseGroupDynamicTypeaheadSelect/Types';
import GroupDynamicTypeaheadSelect from './GroupDynamicTypeaheadSelect';

interface Props {
  successfulParticipantsResource: ImportedParticipantsResource;
  addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore;
}

const handleSelectionChange =
  (addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore) =>
  (selectedValue: FilterOption) => {
    addParticipantsToGroupFormStore.setGroup({
      value: selectedValue.value,
      label: selectedValue.label,
      participantCount: selectedValue.participantCount,
    });
  };

function GroupForm({ successfulParticipantsResource, addParticipantsToGroupFormStore }: Props) {
  return findLink('options', successfulParticipantsResource.links)
    .map((link) => (
      <GroupDynamicTypeaheadSelect
        endpoint={link}
        onChange={handleSelectionChange(addParticipantsToGroupFormStore)}
      />
    ))
    .getOrElse(emptyFragment);
}

export default observer(GroupForm);
